<template>
  <div>
    <v-card
      max-width="330px"
      min-height="100%"
      raised
      :draggable="$vuetify.breakpoint.smAndUp"
      @dragstart="onProcDragStart"
      @dragend="onProcDragEnd"
      class="mx-auto d-flex flex-column"
      :class="`proc-${processing['ab_processing_status'].toLowerCase()}`"
    >
      <v-container
        fluid
        class="map-container ma-0 pa-0"
      >
        <v-row
          align="center"
          justify="center"
          class="grey lighten-4 ma-0 fill-height"
        >

          <v-flex
            v-if="mustShowProcessingMap"
            class="fill-height"
          >
            <processing-card-map
              :processing="processing"
            >
            </processing-card-map>
          </v-flex>
          <empty-state
            v-show="!mustShowProcessingMap"
            color="info"
            class="fill-height"
          >
            <template v-slot:svgIcon>
              <component
                v-if="processingTypeIsFP"
                :is="droneImageryIcon"
                class="svg-icon"
              />
              <component
                v-else
                :is="orthomosaicIcon"
                class="svg-icon"
              />
            </template>
          </empty-state>
        </v-row>
      </v-container>
      <v-card-text
        ref="drag-handler"
        class="processing-card-drag-handler flex-fill"
      >
        <v-container
          fluid
          class="fill-height processing-card__container ma-0 pa-0"
        >
          <!--Date-->
          <v-row
            align="center"
            justify="start"
            class="pa-1 ma-0"
          >    
            <div v-if="processingInODM">
              <v-icon color="indigo darken-3" left small>
                mdi-fire
              </v-icon>    
              <span>-</span>        
            </div>          
            <span class="caption caption-l">{{processing["dh_created"] | humanizeDate}}</span>
            <v-spacer></v-spacer>
          </v-row>
          <!--Name-->
          <v-row
            align="center"
            justify="start"
            class="pa-1 ma-0 flex-fill"
          >
            <!-- <v-icon left v-if="processingInODM">
              mdi-fire
            </v-icon>           -->
            <span class="subtitle-1 text-left">{{processing["nm_processing"]}}</span>
          </v-row>
          <!--Status-->
          <v-row
            align="center"
            justify="start"
            class="pa-1 ma-0"
          >
            <v-col
              cols="12"
              class="pa-0 text-break text-left"
            >
              <v-icon
                :color="processingStatusIconColor"
                :class="['mr-2', processingStatusClass]"
              >
                {{processingStatusIcon}}
              </v-icon>
              <span :id="textId" class="subtitle-2 text-uppercase processing-status-text">{{processingStatusText}}</span>
            </v-col>        
            <v-col
              cols="12"
              class="pa-0 text-truncate text-left"
            >
              <span
                v-if="showEstimatedTime"
                class="caption"
              >
                Tempo estimado: {{processingEstimatedTime}}
              </span>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-row
          class="ma-0"
        >       
          <v-menu
            offset-y
            transition="scale-transition"
            :close-on-content-click="true"
          >
            <template v-slot:activator="{ on: menu }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                  <v-btn
                    color="primary"
                    icon
                    v-on="{...menu, ...tooltip}"
                    class="mx-1"
                  >
                    <v-icon>mdi-menu</v-icon>
                  </v-btn>
                </template>
                <span>Mais ações</span>
              </v-tooltip>
            </template>
            <v-list
              rounded
              dense
              flat
            >
              <v-subheader>Ações</v-subheader>
              <v-list-item-group
                color="primary"
              >
                <v-list-item
                  v-show="$vuetify.breakpoint.smAndUp"
                  @click="onRenameClick"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-form-textbox</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Renomear</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  v-show="$vuetify.breakpoint.smAndUp"
                  :disabled="editButtonIsDisabled"
                  @click="onEditClick"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-pencil</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Editar</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  v-if="$store.state.user.userData.blAllowAdmin"
                  @click="onDuplicateClick"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-file</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Duplicar</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  :disabled="deleteButtonIsDisabled || isDeleting"
                  :color="!deleteButtonIsDisabled ? 'error' : ''"
                  @click="onDeleteClick"
                >
                  <v-list-item-icon>
                    <v-progress-circular
                      v-if="isDeleting"
                      indeterminate
                      color="error"
                      size="20"
                    />
                    <v-icon v-else :color="!deleteButtonIsDisabled ? 'error' : ''">mdi-delete</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Excluir</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  @click="requestReprocessing"
                  v-if="processingStatusText == 'Erro inesperado'">
                  <v-list-item-icon>
                    <v-icon color="accent">mdi-autorenew</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Solicitar Reprocessamento</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <!-- <v-list-item
                  v-if="processingStatusText == 'Processamento arquivado'">
                  <v-list-item-content>
                    <v-list-item-title>DESARQUIVAR</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>               -->
              </v-list-item-group>
            </v-list>
          </v-menu>
          <processing-share-dialog
            :processing="processing"
          >
            <template v-slot:activator="{ on: dialog }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                  <v-btn
                    v-on="{...dialog, ...tooltip}"
                    icon
                    color="primary"
                    :disabled="shareButtonIsDisabled"
                    class="mx-1"
                  >
                    <v-icon>mdi-share-variant</v-icon>
                  </v-btn>
                </template>
                <span>Compartilhar</span>
              </v-tooltip>
            </template>
          </processing-share-dialog>
          <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                v-show="$vuetify.breakpoint.smAndUp"
                v-on="{...tooltip}"
                @click="onUploadClick"
                icon
                color="primary"
                :disabled="uploadButtonIsDisabled"
                class="mx-1"
              >
                <v-icon>mdi-cloud-upload</v-icon>
              </v-btn>
            </template>
            <span>Upload</span>
          </v-tooltip>
          <processing-downloads
            :id-processing="processing['id_processing']"
            :processing="processing"
          >
            <template v-slot:activator="{ on: dialog}">
              <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                  <v-btn
                    :id="`download-${textId}`"
                    v-on="{...dialog, ...tooltip}"
                    icon
                    color="primary"
                    :disabled="downloadButtonIsDisabled"
                    class="mx-1"
                  >
                    <v-icon>mdi-cloud-download</v-icon>
                  </v-btn>
                </template>
                <span>Download</span>
              </v-tooltip>
            </template>
          </processing-downloads>
          <processing-move-dialog
            :processing="processing"
          >
            <template v-slot:activator="{ on: dialog}">
              <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                  <v-btn
                    v-on="{...dialog, ...tooltip}"
                    icon
                    color="primary"
                    class="mx-1"
                  >
                    <v-icon>mdi-folder-move</v-icon>
                  </v-btn>
                </template>
                <span>Mover para pasta</span>
              </v-tooltip>
            </template>
          </processing-move-dialog>
          <v-spacer/>
          <v-btn
            text
            outlined
            color="accent"
            @click="openProcessing(processing['id_processing'])"
            :disabled="!mustShowProcessingMap"
          >
            Abrir
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
    <v-dialog
      v-model="showEmailModal"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Duplicar processamento
        </v-card-title>
        <v-card-text class="pa-7">
          <p>Por favor, informe o e-mail da conta para a qual quer duplicar esse processamento:</p>
          <v-text-field
            v-model="shareEmail"
            label="Email"
            clearable
          ></v-text-field>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="accent"
            text
            @click="showEmailModal = false"
          >
            Fechar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="onConfirmDuplicate"
            :disabled="!shareEmail.length"
          >
            Duplicar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showRenameModal"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Renomear processamento
        </v-card-title>
        <v-card-text class="pa-7">
          <p>Para renomear o processamento altere a caixa de texto abaixo: </p>
          <v-text-field
            v-model="renameProcessingValue"
            label="Nome do processamento"
            clearable
          ></v-text-field>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="accent"
            text
            @click="showRenameModal = false"
          >
            Fechar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="renameProcessing"
            :disabled="!renameProcessingValue.length"
          >
            Renomear
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import Vue from "vue"
  import moment from "moment"
  import {find, includes} from "lodash/collection"
  import {
    PROCESSING_STATUS,
    PROCESSING_STATUS_DETAILS, PROCESSING_TYPES,
  } from "../../helpers/processings/constants"
  import EmptyState from "../Helpers/EmptyState"
  import {mapActions} from "vuex"
  import {
    CLEAN_PROCESSING,
    DELETE_PROCESSING,
    SET_ID_PROCESSING,
    UPDATE_PROCESSING,
    LIST_PROCESSING,
  } from "../../store/modules/processing"
  import {createEventInternal} from "../../api/api-project"
  import {
    requestReprocess,
    processingDuplicate
  } from "../../api/api-project"  
  import {DIALOG_TYPES, DialogOptions} from "../../helpers/dialogs"
  import ProcessingDownloads from "./ProcessingDownloads"
  import ProcessingMoveDialog from "./ProcessingMoveDialog"
  import ProcessingShareDialog from "./ProcessingShareDialog"
  import ProcessingCardMap from "./ProcessingCardMap"
  import {isEqual} from "lodash/lang"
  import ProcessingCardDragGhost from "./ProcessingCardDragGhost"
  import {MainVue} from "../../main"
  import {NOTIFICATION_TYPES, NotificationOptions} from "../../helpers/notify"

  export default {
    name: "ProcessingCard",
    props: {
      processing: {
        type: Object,
        required: true,
      },
      idx: {
        required: true
      }
    },
    components: {
      ProcessingShareDialog,
      ProcessingMoveDialog,
      ProcessingDownloads,
      EmptyState,
      ProcessingCardMap,
    },
    data: () => ({
      isDeleting: false,
      isRequestingUnarchiving: false,
      dragEl: null,
      shareEmail: "",
      renameProcessingValue: '',
      showEmailModal: false,
      showRenameModal: false
    }),
    methods: {
      openProcessing(id_processing) {
        let event_name = 'VIEWED_PROCESSING'

        const authToken = this.$apiAuth.getAuthToken()

        let data_send = {
          "event_name": event_name,
          "cd_processing": id_processing
        }
        createEventInternal(authToken, data_send)
        .then(() => {
          console.log("INTERNAL EVENT CREATED")
        })
        .catch(() => {
          console.log("ERROR CREATE INTERNAL EVENT")
        })        
        this.$router.push("/app/processing/map/"+id_processing)
      },
      onProcDragStart(e) {
        const GhostClass = Vue.extend(ProcessingCardDragGhost)
        const ghostInstance = new GhostClass({
          parent: MainVue,
          propsData: {
            processing: this.processing
          }
        })
        ghostInstance.$mount()
        this.dragEl = ghostInstance.$el.cloneNode(true)
        document.body.appendChild(this.dragEl)
        this.dragEl.style.position = "absolute"
        this.dragEl.style.top = "-9999px"
        e.dataTransfer.dropEffect = 'move';
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData("idProcessing", this.processing["id_processing"])
        e.dataTransfer.setData("nmProcessing", this.processing["nm_processing"])
        e.dataTransfer.setDragImage(this.dragEl, 0, 0);
      },
      onProcDragEnd() {
        document.body.removeChild(this.dragEl)
        this.dragEl = null
      },
      onUploadClick() {
        this.$appMng.setIsLoadingPage(true)
        this.cleanProcessing().then(() => {
          this.setIdProcessing(this.processing["id_processing"])
        }).catch(() => {
          this.$appMng.setIsLoadingPage(false)
        }).finally(() => {
          this.$router.push("/app/processing")
        })
      },
      onRenameClick() {
        this.showRenameModal = true
      },
      renameProcessingHandler() {
        const authToken = this.$apiAuth.getAuthToken()
        const dataSend = {
          idProcessing: this.processing['id_processing'],
          processingData: { nm_processing: this.renameProcessingValue }
        }
        const eventData = {
          event_name: 'RENAME_PROCESSING',
          cd_processing: this.processing['id_processing']
        }

        this._updateProcessing(dataSend)
          .then(() => {
            this.$notify(new NotificationOptions({
              message: "Processamento renomeado com sucesso!",
              type: NOTIFICATION_TYPES.SUCCESS,
            }))

            createEventInternal(authToken, eventData)
              .then(() => console.log("INTERNAL EVENT CREATED"))
              .catch(() => console.log("ERROR CREATE INTERNAL EVENT"))
        })
      },
      renameProcessing() {
        const authToken = this.$apiAuth.getAuthToken()

        this._listProcessing(authToken).then(({ data }) => {
          const nameExists = Array.from(data.data).some(processing => (
            processing.nm_processing === this.renameProcessingValue
          ))

          if(nameExists) {
            this.$notify(new NotificationOptions({
              message: "O nome do processamento já existe!",
              type: NOTIFICATION_TYPES.ERROR,
            }))

            return;
          }
          this.renameProcessingHandler()
        })
        .catch(() => {
          this.$notify(new NotificationOptions({
            message: "Ocorreu um erro na tentativa de renomear o processamento!",
            type: NOTIFICATION_TYPES.ERROR,
          }))
        })
        .finally(() => {
          this.showRenameModal = false
        })
      },
      onEditClick() {
        this.$appMng.setIsLoadingPage(true)
        this.cleanProcessing().then(() => {
          this.setIdProcessing(this.processing["id_processing"])
        }).catch(() => {
          this.$appMng.setIsLoadingPage(false)
        }).finally(() => {
          this.$router.push("/app/processing")
        })
      },
      onDuplicateClick() {
        this.showEmailModal = true
      },
      onConfirmDuplicate() {
        this.showEmailModal = false
        const id = this.processing["id_processing"]
        const data = {email: this.shareEmail}
        processingDuplicate(this.$apiAuth.getAuthToken(), id, data)
          .then((res) => {
            if (res) {
              this.$notify(new NotificationOptions({
                message: "Processamento duplicado com sucesso para o email " + this.shareEmail,
                type: NOTIFICATION_TYPES.SUCCESS,
              }))
            } else  {
              this.$notify(new NotificationOptions({
                message: "Houve um problema ao duplicar o processamento para o email " + this.shareEmail,
                type: NOTIFICATION_TYPES.ERROR,
              }))
            }
          })
          .catch(() => {
            this.$notify(new NotificationOptions({
              message: "Houve um problema ao duplicar o processamento",
              type: NOTIFICATION_TYPES.ERROR,
            }))
          })
      },
      onDeleteClick() {
        this.$dialog(new DialogOptions({
          title: "Excluir Processamento",
          content: "O processo de exclusão remove todos os dados de seu processamento de forma permanente. Você tem certeza que deseja excluir este processamento?",
          onConfirm: this.deleteProcessingHandler,
          type: DIALOG_TYPES.CONFIRM,
        }))
      },
      deleteProcessingHandler() {
        this.isDeleting = true
        this._deleteProcessing(this.processing["id_processing"])
          .then(() => {
            this.$notify(new NotificationOptions({
              message: "Processamento excluído com sucesso!",
              type: NOTIFICATION_TYPES.SUCCESS,
            })) 
          })
          .catch(() => {
            this.$notify(new NotificationOptions({
              message: "Não conseguimos excluir o processamento.  Tente novamente mais tarde.",
              type: NOTIFICATION_TYPES.ERROR,
            })) 
          })
          .finally(() => {
            this.isDeleting = false
            this._listProcessing()
              .finally(() => {
                this.isDeleting = false  
              })
          })
      },
      requestReprocessing() {
        requestReprocess(
          this.$apiAuth.getAuthToken(),
          this.$store.state.user.userData.idUserAccount,
          this.processing['id_processing']
        )
        .then((res) => {
          if (res.data.data.status == 200) {
            this.$emit('reprocessRequest', this.idx)
          }
          if (res.data.data.status == 422) {
            this.$notify(new NotificationOptions({
              message: "Status do processamento não pôde ser atualizado",
              type: NOTIFICATION_TYPES.ERROR,
            }))
          }
        })
        .catch(() => {
            this.$notify(new NotificationOptions({
              message: "Houve um erro ao solicitar o reprocessamento",
              type: NOTIFICATION_TYPES.ERROR,
            }))
        })
      },
      ...mapActions({
        cleanProcessing: CLEAN_PROCESSING,
        setIdProcessing: SET_ID_PROCESSING,
        _updateProcessing: UPDATE_PROCESSING,
        _deleteProcessing: DELETE_PROCESSING,
        _listProcessing: LIST_PROCESSING
      }),
    },
    filters: {
      humanizeDate(date) {
        return moment(date).format("DD/MM/YYYY")
      },
    },
    computed: {
      textId() {
        return this.processing["nm_processing"].toLowerCase().replace(/\s/g, '');
      },
      processingInODM() {
        return isEqual(this.processing["bl_use_odm"], true)
      },      
      processingTypeIsFP() {
        return isEqual(this.processing["ab_processing_type"], PROCESSING_TYPES.FULL_PROCESSING)
      },
      processingStatusIcon() {
        return find(PROCESSING_STATUS_DETAILS, ["value", this.processing["ab_processing_status"]]).icon
      },
      processingStatusClass() {
        return find(PROCESSING_STATUS_DETAILS, ["value", this.processing["ab_processing_status"]]).class
      },
      processingStatusIconColor() {
        return find(PROCESSING_STATUS_DETAILS, ["value", this.processing["ab_processing_status"]]).color
      },
      processingStatusText() {
        return find(PROCESSING_STATUS_DETAILS, ["value", this.processing["ab_processing_status"]]).name
      },
      showEstimatedTime() {
        let lst = [
          PROCESSING_STATUS.PROCESSING,
        ]
        return includes(lst, this.processing["ab_processing_status"])
      },
      processingEstimatedTime() {
        return moment.utc(this.processing["int_estimated_time_secs"] * 1000).format("HH:mm")
      },
      mustShowProcessingMap() {
        return includes([PROCESSING_STATUS.ENDED], this.processing["ab_processing_status"])
      },
      deleteButtonIsDisabled() {
        return !includes(
          [
            PROCESSING_STATUS.ENDED,
            PROCESSING_STATUS.CREATED,
            PROCESSING_STATUS.READY_TO_UPLOAD,
            PROCESSING_STATUS.WAITING_PAYMENT,
            PROCESSING_STATUS.READY_TO_PAY,
            PROCESSING_STATUS.ERROR,
          ],
          this.processing["ab_processing_status"],
        )
      },
      editButtonIsDisabled() {
        return !includes(
          [
            PROCESSING_STATUS.CREATED,
          ],
          this.processing["ab_processing_status"],
        )
      },
      uploadButtonIsDisabled() {
        return !includes(
          [
            PROCESSING_STATUS.READY_TO_UPLOAD,
          ],
          this.processing["ab_processing_status"],
        )
      },
      downloadButtonIsDisabled() {
        return !includes(
          [
            PROCESSING_STATUS.ENDED,
          ],
          this.processing["ab_processing_status"],
        )
      },
      shareButtonIsDisabled() {
        return !includes(
          [
            ...Object.values(PROCESSING_STATUS),
          ],
          this.processing["ab_processing_status"],
        )
      },
      droneImageryIcon() {
        const SVGIcon = require("../../assets/processings/drone-imagery.svg?inline")
        return SVGIcon.default
      },
      orthomosaicIcon() {
        const SVGIcon = require("../../assets/processings/orthomosaic.svg?inline")
        return SVGIcon.default
      },
    },
  }
</script>

<style scoped lang="scss">
  .map-container {
    height: 200px;
  }

  .processing-card-drag-handler {
    cursor: grab;
  }

  .svg-icon {
    display: flex;
    flex: 0 0 50%;
    fill: var(--v-accent-base);
  }

  .v-card__text {
    padding-bottom: 0;
  }

  .processing-card__container {
    min-height: 100%;
  }

  .caption-l {
    margin-left: 10px !important;
  }
</style>
